import React, { useEffect, useState } from 'react'
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

function ActionViewModalContent(props) {
    const [isCopied, setIsCopied] = useState(false);

    //copy text fn
    const handleCopyClick = (e) => {
        const textArea = document.createElement('textarea');
        let copyData = "";
        copyData = props.actionText;
        textArea.value = copyData;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        setIsCopied(true);
        setTimeout(() => {
            setIsCopied(false);
        }, 1000);
    };

    return (
        <>
            <div className="gridcontainer">
                <div className="modalinnerbody">
                    <div className="innerbodydimension">
                        <div className="input-group copyGroup">
                            <fieldset>
                                <p className='webhook_url'>{props.actionText}</p>
                                <div className="input-group-append">
                                    <button onClick={(e) => { handleCopyClick(e) }} className="btn btn-primary border-form border-top-bottom-right-radius-4" type="button">
                                        <OverlayTrigger overlay={<Tooltip>{"Copy"}</Tooltip>}>
                                            <i className="fa fa-clone" aria-hidden="true"></i>
                                        </OverlayTrigger>
                                    </button>
                                </div>
                            </fieldset>
                        </div>
                        <div className='responseBox msg_text'>{isCopied && <p className='responseCope'>Text copied to clipboard!</p>}</div>
                    </div>
                </div>
            </div>
        </>
    )
}

ActionViewModalContent.defaultProps = {
}

export default ActionViewModalContent;